import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import classNames from "classnames";
import { Icon } from "./../../Common/Icon";

class Box extends PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    className: PropTypes.string,
    isOpen: PropTypes.bool,
    optionsClick: PropTypes.func
  };

  static defaultProps = {
    className: "",
    isOpen: false
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClick, false);
  }

  settingsRef = React.createRef();

  handleClick = e => {
    const isClickOutsideSettings = !this.settingsRef.current.contains(e.target);

    if (isClickOutsideSettings) {
      this.props.optionsClick(false);
    }
  };

  handleOptionsClick = () => {
    this.props.optionsClick(false);
  };

  render() {
    return (
      <div ref={this.settingsRef} className={classNames("box", this.props.isOpen && "--open", this.props.className)}>
        <Icon onClick={this.handleOptionsClick} className={classNames("box__close", this.props.className)} id="x" />
        {this.props.children}
      </div>
    );
  }
}

export default Box;



// WEBPACK FOOTER //
// ./src/components/Common/UnitsSelector/Box.js